import React from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { ENV_NAME, FLUTTER_INSIGHTS_URL } from "../utils/constants";

// console.log('ENV NAME is ', ENV_NAME)
import {
  Navbar,
  NavbarBrand,
  NavbarContent,
  NavbarItem,
  Link,

} from "@heroui/react";
import EnvRibbon from "./EnvRibbon";
import AppSwitcher from "./AppSwitcher";


interface bannerProps {
  current: "upload" | "report" | "ingestion" | "status";
}

const Banner: React.FC<bannerProps> = ({ current }) => {
  const { instance } = useMsal();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await instance
      .logoutRedirect()
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        navigate("/");
      });
  };

  // const ENV_NAME = "uat";

  return (
    <div className=" relative  overflow-hidden">
      {/* <div className="flex bg-transparent"> */}
      <Navbar
        maxWidth="full"
        className=" bg-primary flex justify-between items-center "
      >

        <NavbarContent className="gap-4">
          {/* App switcher  + Logo  */}
          <AppSwitcher />

          {/* Environment Ribbon  */}
          <EnvRibbon env={ENV_NAME as "prod" | "uat" | "dev"} />
          {/* <NavbarContent> */}
          <img src={"/images/bannerLogo.svg"} alt="logo" className="h-[4rem]" />
          
          <NavbarBrand>
            <p className="text-white font-bold text-lg ml-[-0.5rem]">
              GPSC Insight Document Management
            </p>
          </NavbarBrand>
        </NavbarContent>
        <div className="float-right mr-[2rem] bg-transparent ">
          <NavbarContent>

            <NavbarItem>
              <Link
                href={current == "upload" ? undefined : "/upload"}
                className="bg-transparent text-white text-lg mr-[1.5rem]"
                underline={current == "upload" ? "always" : "hover"}
                size="sm"
              >
                Upload
              </Link>
              <Link
                href={current == "status" ? undefined : "/status"}
                className="bg-transparent text-white text-lg mr-[1.5rem]"
                underline={current == "status" ? "always" : "hover"}
                size="sm"
              >
                Status
              </Link>
              <Link
                href={current == "report" ? undefined : "/report"}
                className="bg-transparent text-white text-lg mr-[1.5rem]"
                underline={current == "report" ? "always" : "hover"}
                size="sm"
              >
                Report
              </Link>
              <Link
                href={current == "ingestion" ? undefined : "/ingestion"}
                className="bg-transparent text-white text-lg mr-[1.5rem]"
                underline={current == "ingestion" ? "always" : "hover"}
                size="sm"
              >
                Ingestion
              </Link>
            </NavbarItem>
            {/* <NavbarItem>
              <Button
                isIconOnly
                className="bg-transparent"
                onPress={handleLogout}
              >
                <img
                  src={"/images/logout.svg"}
                  alt="logout"
                  className="h-[1.75rem]"
                />

              </Button>

            </NavbarItem> */}
          </NavbarContent>
          </div>
        
      </Navbar>
    {/* </div> */}
    </div>

  );
};

export default Banner;
